import {ResultadoDelConsolidadoSchema} from '@cnc/contracts';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {pedir} from './cliente';
import {refrescarDatos} from './refrescar';

export type EleccionesDelConsolidado = {corregir: string[]; meses: string[]; liberar: string[]};

// Consolidated Shipments vigente: "revisar" no guarda; "aplicar" guarda con lo elegido.
export function useCargarConsolidado() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({
      archivo,
      modo,
      elecciones,
    }: {
      archivo: File;
      modo: 'revisar' | 'aplicar';
      elecciones: EleccionesDelConsolidado;
    }) => {
      const cuerpo = new FormData();
      cuerpo.append('archivo', archivo, archivo.name);
      cuerpo.append('modo', modo);
      cuerpo.append('corregir', elecciones.corregir.join('|'));
      cuerpo.append('meses', elecciones.meses.join('|'));
      cuerpo.append('liberar', elecciones.liberar.join('|'));
      return pedir('inventario/consolidado', ResultadoDelConsolidadoSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: async resultado => {
      if (resultado.aplicado) await refrescarDatos(cliente);
    },
  });
}
